<template>
    <div>
        <section class="lost-psw">
            <v-container>
                <v-row>
                    <v-col cols="14" offset="1" sm="16" offset-sm="0">
                        <h1 class="section-title">Obnovení zapomenutého hesla</h1>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12" sm="6" offset-sm="5">
                        <v-card flat light>
                            <form @submit.prevent="onLostPassword" ref="lostPasswordForm">
                                <v-card-text>
                                    <p class="lost-psw__infotext">Na zadaný e-mail vám bude odeslán odkaz pro nastavení nového hesla. Platnost odkazu je 24 hodin.</p>
                                    <v-text-field
                                        label="E-mail"
                                        v-model.trim="email"
                                        type="email"
                                        light
                                        :rules="rules.email"
                                        validate-on-blur
                                    ></v-text-field>
                                </v-card-text>
                                <v-divider></v-divider>
                                <v-card-actions>
                                    <v-spacer></v-spacer>
                                    <v-btn type="submit" light class="primary" :disabled="loading || !isFormValid" :loading="loading">
                                        Odeslat
                                    </v-btn>
                                </v-card-actions>
                            </form>
                        </v-card>
                    </v-col>
                </v-row>
            </v-container>
        </section>
        <cta-block></cta-block>
    </div>
</template>
<script>
    import { LOST_PASSWORD_REQUEST } from '../store/actions/user'
    import { validator } from '../plugins/validator'
    import CtaBlock from '../components/Graphics/CtaBlock.vue'

    export default {
        components: {
             CtaBlock,
        },
        data () {
            return {
                email: '',
                loading: false,
            };
        },
        computed: {
            isFormValid () {
                return this.email !== '' && validator.email(this.email) === true;
            },
            rules () {
                return {
                    email: [validator.required, validator.email],
                }
            },
        },
        methods: {
            async onLostPassword () {
                if (!this.isFormValid) {
                    return;
                }

                try {
                    this.loading = true;
                    await this.$store.dispatch('user/' + LOST_PASSWORD_REQUEST, { email: this.email });
                    this.$refs.lostPasswordForm.reset();
                    this.$toast.success('Pokyny k obnovení hesla byly odeslány na váš e-mail.');
                } catch (e) {
                    const message = e.response.data.message || 'Došlo k chybě. Zkuste to později.';
                    this.$toast.error(message);
                } finally {
                    this.loading = false;
                }
            },
        },
    }
</script>
